import { HTTP_STATUS_NOT_FOUND } from '../../../constants/api'
import { ErrorPage } from '../ErrorPage'

function ErrorPageNotFound() {
  return <ErrorPage status={HTTP_STATUS_NOT_FOUND} />
}

export default ErrorPageNotFound
